import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getProducerCode = async () => {
  return axios.get(`${api_base_url}/ProducerCode`).then((res) => {
    if (res) {
      if (res.data) {
        return res.data;
      }
    } else {
      return res;
    }
  });
};

export const getProducerCodeCount = async () => {
  return axios.get(`${api_base_url}/ProducerCode/ProducerCodeCount`);
};

export const getProducerCodeReportDetails = async () => {
  const res = await axios.get(
    `${api_base_url}/ProducerCode/ProducerCodeReport`
  );
  return res.data;
};

export const searchModalProducerCode = (carrierId, stateCode, producerCode) => {
  var statecodes = stateCode.replace(/ /g, "").replace(/,/g, "-");

  return axios
    .post(
      `${api_base_url}/ProducerCode/${carrierId},${
        stateCode === "" ? "null" : statecodes
      },${producerCode}`
    )
    .then((res) => res.data);
};

export const getProdCodeListByCarrierId = (carrierId) => {
  return axios
    .post(`${api_base_url}/ProducerCode/ByCarrierId/${carrierId}`)
    .then((res) => res.data);
};

export const getProducerCodeByOffice = (officeCode) => {
  return axios
    .post(`${api_base_url}/ProducerCode/${officeCode}`)
    .then((res) => res.data);
};

export const getById = async (carrierProducerCodeId) => {
  return await axios
    .get(`${api_base_url}/ProducerCode/${carrierProducerCodeId}`)
    .then((res) => res.data);
};

export const getProducerCodeByCarrierProducerCodeId = async (id) => {
  return await axios.get(`${api_base_url}/ProducerCode/${id}`).then((res) => {
    return res.data;
  });
};

export const getProducerCodeListByCarrierProducerCodeIds = async (
  carrierProducerCodes
) => {
  const data = {
    carrierName: carrierProducerCodes.carrierName,
    masterCarrierAddress: carrierProducerCodes.masterCarrierAddress,
    state: carrierProducerCodes.state,
    producerCodes: carrierProducerCodes.producerCodes,
    masterCarrierId: carrierProducerCodes.masterCarrierId,
    carrierProducerCodeIds: carrierProducerCodes.carrierProducerCodeIds,
  };
  return axios
    .post(
      `${api_base_url}/ProducerCode/GetProducerCodeListByCarrierProducerCodeIds`,
      data
    )
    .then((res) => res.data);
};

//to be deleted
export const getProducerCodeListByListCarrierProducerCodeIds = async (
  carrierProducerCodes
) => {
  return axios
    .post(
      `${api_base_url}/ProducerCode/GetProducerCodeListByListCarrierProducerCodeIds`,
      carrierProducerCodes
    )
    .then((res) => res.data);
};

export const searchProducerCodes = async ({ queryKey }) => {
  //Recontruct filter parameter as Query String for GET Method [FromQuery]
  const [_key, filters] = queryKey;

  var queryStrings = new URLSearchParams();
  if (filters) {
    if (filters.selectedFranchiseConfie?.value >= 0) {
      if (filters.selectedFranchiseConfie.value === 1) {
        queryStrings.append("IsFranchise", true);
      } else if (filters.selectedFranchiseConfie.value === 3) {
        queryStrings.append("IsFranchise", true);
        queryStrings.append("IsConfieFranchise", true);
      } else {
        queryStrings.append("IsFranchise", false);
      }
    }
    filters.CarrierName &&
      filters.CarrierName.map((x) => queryStrings.append("CarrierName", x));
    filters.OfficeName &&
      filters.OfficeName.map((x) => queryStrings.append("OfficeName", x));
    filters.OfficeCode &&
      filters.OfficeCode.map((x) => queryStrings.append("OfficeCode", x));
    filters.State && filters.State.map((x) => queryStrings.append("States", x));
    filters.ProducerCode !== undefined &&
      queryStrings.append("ProducerCode", filters.ProducerCode);
    filters.MAProducerCode !== undefined &&
      queryStrings.append("MAProducerCode", filters.MAProducerCode);
    filters.AcquisitionName !== undefined &&
      queryStrings.append("AcquisitionName", filters.AcquisitionName);
    filters.BillingId && queryStrings.append("BillingId", filters.BillingId);
  }
  var filterParams = {
    params: queryStrings,
  };
  return await axios
    .get(`${api_base_url}/ProducerCode/SearchProducerCode`, filterParams)
    .then((res) => res.data);
};

export const searchProducerCode = (args) => {
  return axios.post(`${api_base_url}/searchAgreement`, args).then((res) => {
    return res.data;
  });
};

export const addProducerCode = async (newProducerCode) => {
  newProducerCode?.issuedTo &&
    newProducerCode?.issuedTo.map((x) => x.value)?.join(",");
  newProducerCode.issuedTo =
    newProducerCode?.issuedTo &&
    newProducerCode?.issuedTo.map((x) => x.value)?.join(",");
  newProducerCode.crossSale =
    newProducerCode?.crossSale &&
    newProducerCode?.crossSale?.map((x) => x.value).includes("ALL")
      ? "ALL"
      : newProducerCode?.crossSale?.map((x) => x.value)?.join(",");
  return await axios.post(`${api_base_url}/ProducerCode`, newProducerCode);
};

export const updateProducerCode = async (producerCode) => {
  producerCode.issuedTo = Array.isArray(producerCode?.issuedTo)
    ? producerCode.issuedTo
        .map((x) => x?.value ?? "")
        .filter((y) => y)
        .join(",")
    : "";
  producerCode.crossSale = Array.isArray(producerCode?.crossSale)
    ? producerCode.crossSale.map((x) => x.value).includes("ALL")
      ? "ALL"
      : producerCode.crossSale.map((x) => x.value).join(",")
    : producerCode.crossSale || "";
  return await axios.put(
    `${api_base_url}/ProducerCode/${producerCode.CarrierProducerCodeId}`,
    producerCode
  );
};

export const deleteProducerCodes = async (producerCodeIds, userName) => {
  return await axios.delete(`${api_base_url}/ProducerCode/${userName}`, {
    data: producerCodeIds,
  });
};

export const exportProducerCodes = async (
  exportInputsData,
  isFranchise,
  isConfie
) => {
  var response = await axios.post(
    `${api_base_url}/ProducerCode/ExportExcel?isFranchise=${isFranchise}&isConfie=${isConfie}`,
    exportInputsData,
    {
      headers: { "Content-Type": "application/json" },
      responseType: "blob",
    }
  );
  return response;
};

export const downloadProdCodeTemplate = async () => {
  var response = await axios.get(
    `${api_base_url}/ProducerCode/download/template`,
    {
      headers: { "Content-Type": "application/json" },
      responseType: "blob",
    }
  );
  return response;
};

export const validateMassUpload = (data) => {
  data.issuedToList =
    data.issuedToList && data.issuedToList.map((x) => x.value)?.join(",");
  data.crossSaleList =
    data.crossSaleList && data.crossSaleList.map((x) => x.value)?.join(",");
  return axios
    .post(`${api_base_url}/ProducerCode/validate`, data)
    .then((res) => {
      if (res) {
        if (res.data) {
          return res.data;
        } else {
          return res;
        }
      } else {
        return res;
      }
    });
};

export const massUploadProducerCode = (data) => {
  return axios
    .post(`${api_base_url}/ProducerCode/mass-upload`, data)
    .then((res) => {
      return res;
    });
};

export const searchSubProducerCodeCriteria = async (searchInputsData) => {
  // let CarrierName = "";
  // CarrierName.push(searchInputsData.carrierProducerCodes.carrierName);
  const data = {
    carrierName: searchInputsData.CarrierName,
    officeName:
      searchInputsData.OfficeName === "" ? [] : searchInputsData.OfficeName,
    officeCode:
      searchInputsData.OfficeCode === "" ? [] : searchInputsData.OfficeCode,
    states: searchInputsData.State === "" ? [] : searchInputsData.State,
    producerCode:
      searchInputsData.ProducerCode === undefined
        ? ""
        : searchInputsData.ProducerCode,
    maProducerCode:
      searchInputsData.MAProducerCode === undefined
        ? ""
        : searchInputsData.MAProducerCode,
    isFranchise:
      searchInputsData.selectedFranchiseConfie.value === 2 ? true : false,
    isConfie:
      searchInputsData.selectedFranchiseConfie.value === 1 ? true : false,
    IsConfieFranchise:
      searchInputsData.selectedFranchiseConfie.value === 3 ? true : false,
    acquisitionName:
      searchInputsData.AcquisitionName === undefined
        ? ""
        : searchInputsData.AcquisitionName,
    carrierProducerCodes:
      searchInputsData.carrierProducerCodes === undefined
        ? null
        : searchInputsData.carrierProducerCodes,
    carrier: searchInputsData.carrierProducerCodes.carrierName,
    billingId:
      searchInputsData.BillingId === undefined
        ? null
        : searchInputsData.BillingId,
    isConfieFranchise:
      searchInputsData.selectedFranchiseConfie.value === 3 ? true : false,
    isFranchiseType:
      searchInputsData.selectedFranchiseConfie.value === 4 ? true : false,
  };
  return await axios
    .post(`${api_base_url}/ProducerCode/SubSearchProducerCode`, data)
    .then((res) => res.data);
};

export const getProdCodeStates = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/ProducerCodeStates`
  );
  return data;
};

export const getProdFranchiseTypes = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/ProducerFranchiseTypes`
  );
  return data;
};

export const getCarrierNameLists = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/carrierNameList`
  );
  return data;
};

export const getIdsForDownload = (data) => {
  return axios
    .post(`${api_base_url}/ProducerCode/forDownload`, data)
    .then((res) => res.data);
};

export const getBilling = async () => {
  const { data } = await axios.get(`${api_base_url}/ProducerCode/Billing`);
  return data;
};

export const processKeeperRecords = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const res = await axios.post(
    `${api_base_url}/ProducerCode/KeeperUpload`,
    formData,
    config
  );
  return res;
};

export const getRecentMappingActivity = async (top = 1000) => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/RecentActivities/Batches?top=${top}`
  );
  return Array.isArray(data) ? data : [];
};

export const getAcquisitions = async () => {
  const { data } = await axios.get(`${api_base_url}/ProducerCode/Acquisitions`);
  return Array.isArray(data) ? data : [];
};

export const getProdFranchiseTypesByName = async (names) => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/FranchiseTypes`,
    { params: { names } }
  );
  return data;
};
export const getProgressiveCodes = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/ProgressiveCode`
  );
  return data;
};

export const getFranchiseTypes = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/GetFranchiseTypes`
  );
  return data || [];
};

export const getCarrierNames = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/GetCarrierNames`
  );
  return data || [];
};

export const getOfficeNames = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/GetOfficeNames`
  );
  return data || [];
};

export const getAcquisitionNames = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/GetAcquisitionNames`
  );
  return data || [];
};

export const getBrandNames = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/GetBrandNames`
  );
  return data || [];
};

export const getStates = async () => {
  const { data } = await axios.get(`${api_base_url}/ProducerCode/GetStates`);
  return data || [];
};

export const getProducerCodeCounts = async (dto) => {
  try {
    const url = `${api_base_url}/ProducerCode/GetProducerCodeCounts`;
    const body = dto == null ? {} : dto;
    const { data } = await axios.post(url, body);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const downloadMultiSheetExcel = async (dto) => {
  const response = await axios.post(
    `${api_base_url}/ProducerCode/downloadDashboard`,
    dto,
    {
      responseType: "blob",
      headers: { "Content-Type": "application/json" },
    }
  );
    
  if (response?.status >= 400) {
    const blob = response?.data;

      if (blob instanceof Blob) {
          const text = await blob.text();
          const { message } = JSON.parse(text);
          throw new Error(message);
      }
  };

  return response;
};

export const handleExcelDownload = async (filters) => {
  try {
    let dateTimeToday = new Date(new Date().toISOString()).toISOString();
    const response = await downloadMultiSheetExcel(filters);

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    link.setAttribute("download", `ProducerCode_${dateTimeToday}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Excel download failed", err);
    throw err;
  }
};

export const exportProducerCode = async (data) => {
  try {
    let dateTimeToday = new Date(new Date().toISOString()).toISOString();

    const response = await axios.post(
      `${api_base_url}/ProducerCode/ExportProducerCode`,
      data,
      {
        responseType: "blob",
      }
    );
    
    if (response?.status >= 400) {
      const blob = response?.data;

        if (blob instanceof Blob) {
            const text = await blob.text();
            const { message } = JSON.parse(text);
            throw new Error(message);
        }
    };

    const blob = new Blob([response.data]);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", "ProducerCode_" + dateTimeToday + ".csv");

    document.body.append(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Failed to download Produce Code", error);
    throw error;
  }
};

export const getDistributionChannels = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ProducerCode/GetDistributionChannels`
  );
  return data || [];
};
